import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import logo from "../../assets/images/heycarter-logo-with-text.png";
import auth from "../../auth/auth";
import { USER_KEY } from "../../utils/constants/SYSTEM";
import { get } from "../../utils/helpers/storage";
import useType from "../../utils/hooks/useType";
import { CancelButton } from "../Controls/CancelButton";
import { LogoutButton } from "../Controls/LogoutButton";
import StackStyle from "../Styled/Stack.style";
import { List, SignOut, XCircle } from "phosphor-react";
import Popup from "../Popup/Popup";
import { useRef } from "react";
import AccentStyle from "../Styled/Accent.style";
import {
  Avatar,
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip,
} from "@mui/material";
import QueueStyle from "../Styled/Queue.style";
import colors from "../../utils/constants/COLORS";
import packageJson from "../../../package.json";

export default function Header() {
  const [user, setUser] = useType("object", get(USER_KEY));
  const [showMenu, setShowMenu] = useType("boolean", false);
  const [showVersion, setShowVersion] = useType("boolean", false);
  const version = packageJson.version;
  const menuRef = useRef();

  const navigate = useNavigate();
  return (
    <Container>
      <SideArea align="start">
        <StackStyle>
          <span>
            Hi <b>{user.fullname}</b>
          </span>
          <span onMouseOver={() => setShowVersion(true)} onMouseLeave={() => setShowVersion(false)}>You are logged into Carter’s Deals Portal. {showVersion && "v" + version}</span>
        </StackStyle>
      </SideArea>
      <StackStyle alignContent="center" width="60%">
        <img
          src={logo}
          alt="Heycarter logo"
          height="40px"
          style={{ justifySelf: "center" }}
        />
        <AccentStyle>
          Our customers are at the core of everything we do
        </AccentStyle>
      </StackStyle>
      <SideArea align="end" ref={menuRef}>
        <Tooltip title="User settings" sx={{ height: "min-content" }}>
          <IconButton onClick={() => setShowMenu(!showMenu)}>
            <List size={18} weight="thin" />
          </IconButton>
        </Tooltip>
        <Popup
          open={showMenu}
          anchor={menuRef.current}
          title={
            <QueueStyle gap="10px">
              <Avatar sx={{ bgcolor: colors.brand }}>{user.fullname[0]}</Avatar>
              {user.fullname}
            </QueueStyle>
          }
          body={
            <MenuItem
              onClick={() => {
                auth.logout();
                navigate("/login");
              }}
            >
              <ListItemIcon>
                <SignOut size={18} weight="thin" />
              </ListItemIcon>
              <LogoutButton />
            </MenuItem>
          }
          action={
            <MenuItem onClick={() => setShowMenu(false)}>
              <ListItemIcon>
                <XCircle size={18} weight="thin" />
              </ListItemIcon>
              <CancelButton />
            </MenuItem>
          }
          variant="info"
          onClose={() => setShowMenu(false)}
        />
      </SideArea>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 1rem;
`;

const SideArea = styled.div`
  display: flex;
  align-content: ${(props) => props.align};
  position: relative;
  width: 20%;
  justify-content: ${(props) => props.align};
  font-size: small;
`;